import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { Login, Register, ForgotPassword, VerifyAccount, Dashboard, Profile, Edit, LoanIndex, Switch, Preview, Terms, Privacy, Contact, NotFound, Settings, AJAServices, PensionPartners } from "./components";
import ProtectedRoute from "./utils/ProtectedRoutes";
import { fetchConfig } from "./providers/configSlice";

function App() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchConfig());
		const refresh = setInterval(() => dispatch(fetchConfig()), 60 * 60 * 1000);  // 1 hour
		return () => clearInterval(refresh);
	}, [dispatch]);

	return (
		<Routes>
			<Route path="/login" element={<Login />} />
			<Route path="/register" element={<Register />} />
			<Route path="/forgot-password" element={<ForgotPassword />} />
			<Route path="/verify-account/:phone" element={<VerifyAccount />} />
			<Route path="/partner/aja-services" element={<AJAServices />} />
			<Route path="/partner/pension" element={<PensionPartners />} />

			<Route element={<ProtectedRoute />}>
				<Route path="/" element={<Dashboard />} />
				<Route path="/profile" element={<Profile />} />
				<Route path="/profile/edit" element={<Edit />} />

				<Route path="/loans" element={<LoanIndex />} />
				<Route path="/loans/:path" element={<Switch />} />

				{/* SECURITY: loanId is user-supplied — backend MUST verify ownership before returning loan data (IDOR risk) */}
				<Route path="/preview/:state/:type/:loanId" element={<Preview />} />

				<Route path="/settings" element={<Settings />} />

				<Route path="/terms" element={<Terms />} />
				<Route path="/privacy-policy" element={<Privacy />} />
				<Route path="/contact" element={<Contact />} />
			</Route>

			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}

export default App;
